var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
// Utils
// @ts-expect-error - TS7006 - Parameter 'arr' implicitly has an 'any' type.
function flatten(arr) {
    // @ts-expect-error - TS2347 - Untyped function calls may not accept type arguments. | TS7006 - Parameter 'acc' implicitly has an 'any' type. | TS7006 - Parameter 'val' implicitly has an 'any' type.
    return arr.reduce(
    // @ts-expect-error - Not sure how to fix this one
    (acc, val) => Array.isArray(val.options)
        ? acc.concat(flatten(val.options))
        : acc.concat(val), []);
}
// @ts-expect-error - TS7006 - Parameter 'x' implicitly has an 'any' type.
const clean = (x) => x.trim();
// @ts-expect-error - TS7006 - Parameter 'str' implicitly has an 'any' type.
const toArray = (str) => str.split(",").map(clean);
// @ts-expect-error - TS7006 - Parameter 'opts' implicitly has an 'any' type. | TS7006 - Parameter 'val' implicitly has an 'any' type. | TS7006 - Parameter 'getOptVal' implicitly has an 'any' type. | TS7006 - Parameter 'isMulti' implicitly has an 'any' type.
function getValue(opts, val, getOptVal, isMulti) {
    if (val == null) {
        return val;
    }
    const options = flatten(opts);
    const value = isMulti
        ? // @ts-expect-error - TS7006 - Parameter 'o' implicitly has an 'any' type.
            options.filter((o) => (Array.isArray(val) ? val : toArray(val)).includes(getOptVal(o)))
        : // @ts-expect-error - TS7006 - Parameter 'o' implicitly has an 'any' type.
            options.find((o) => getOptVal(o) === val);
    return value;
}
// Component
// @ts-expect-error - TS7006 - Parameter 'opt' implicitly has an 'any' type.
const defaultGetOptionValue = (opt) => opt.value;
const ReactSelectSimpleValue = (_a) => {
    var { children, defaultValue: simpleDefault, getOptionValue = defaultGetOptionValue, isMulti = false, options, loadOptions, value: simpleValue } = _a, others = __rest(_a, ["children", "defaultValue", "getOptionValue", "isMulti", "options", "loadOptions", "value"]);
    const [cachedOptions, setCachedOptions] = React.useState([]);
    // @ts-expect-error - TS2774 - This condition will always return true since this function is always defined. Did you mean to call it instead?
    const internalOptions = loadOptions ? cachedOptions : options;
    const wrappedLoadOptions = (search) => __awaiter(void 0, void 0, void 0, function* () {
        const results = yield loadOptions(search);
        setCachedOptions((co) => co.concat(results));
        return results;
    });
    const value = getValue(internalOptions, simpleValue, getOptionValue, isMulti);
    const defaultValue = getValue(internalOptions, simpleDefault, getOptionValue, isMulti);
    return children(Object.assign(Object.assign({}, others), { defaultValue,
        getOptionValue,
        isMulti, 
        // @ts-expect-error - TS2774 - This condition will always return true since this function is always defined. Did you mean to call it instead?
        loadOptions: loadOptions && wrappedLoadOptions, options,
        value }));
};
export default ReactSelectSimpleValue;
